import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8180',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'magisprev',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'magisprev-frontend',
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
